'use client';

import { useDefaultRedirectPerHospital } from '@/hooks';
import { FullPageLoader } from '@/components/loader';

const Home = () => {
  useDefaultRedirectPerHospital();
  return <FullPageLoader />;
};

export default Home;
